module.exports = __webpack_public_path__ + "static/media/Square.ebe6f8b7.png";